import styled from 'styled-components';
import { Typography } from '../../global/theme';
import { AlignCenter } from '../../global/commonStyle';

const RadioContainer = styled.div`
  ${AlignCenter}
  gap: var(--space-8);
  cursor: pointer;
`;

const RadioInput = styled.input`
  appearance: none;
  min-width: 16px;
  height: 16px;
  border: 1px solid var(--border-secondary);
  border-radius: var(--border-radius-full);
  outline: none;
  cursor: pointer;
  position: relative;
  transition: all var(--transition-fast) ease;
  margin: var(--space-0);

  &:checked {
    border-color: var(--brand-primary);
    background-color: var(--brand-primary);

    &::after {
      content: '';
      position: absolute;
      width: 6px;
      height: 6px;
      background-color: var(--text-white);
      border-radius: var(--border-radius-full);
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
`;

const RadioLabel = styled.label`
  ${Typography.body_md};
  color: var(--text-secondary);
  cursor: pointer;
  letter-spacing: 0;
`;

export { RadioContainer, RadioInput, RadioLabel };
